export const LOGGED_OUT_CAT_PAGE_SIZE = 57; // 60 - 3 (banners)
export const LOGGED_OUT_CAT_PAGE_SIZE_WITH_NEW_INLINE_BANNER = 59; // 60 - 1 (brand value pill banner)
